import { CustomColumnGridConfig } from '../types'

const columnsConfig: CustomColumnGridConfig[] = [
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'waterCard',
    headerName: 'מספר כ.מים',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'name',
    headerName: 'שם צרכן',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'payerNumber',
    headerName: 'מספר משלם',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'propertyNumber',
    headerName: 'מספר נכס',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'billingPeriod',
    headerName: 'תקופת חיוב',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'readValue',
    headerName: 'קריאה נוכחית',
    filterSpec: { kind: 'number' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'preValue',
    headerName: 'קריאה קודמת',
    filterSpec: { kind: 'number' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'consumption',
    headerName: 'צ.פרטית לחיוב',
    filterSpec: { kind: 'number' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'shared',
    headerName: 'צריכה משותפת',
    filterSpec: { kind: 'number' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
]

export default columnsConfig
